/**
 * Vintage Iron Cycles — Nearest Store Widget
 * Computes closest showroom using Geolocation or IP fallback,
 * provides manual dropdown select override, and caches preference in localStorage.
 */

(function () {
  // Fallback database of all 16 showrooms with timezones and daily schedules compiled from their page files
  const DEFAULT_STORES = [
    {
      id: "loc_01_victoria",
      name: "Victoria, BC",
      address: "560 Johnson Street, Unit 47",
      city: "Victoria",
      province: "BC",
      postal: "V8W 3C6",
      phone: "250-940-0017",
      website: "/pages/victoria",
      lat: 48.428402,
      lng: -123.368206,
      timezone: "America/Vancouver",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 6:00 PM"
      }
    },
    {
      id: "loc_02_vancouver",
      name: "Vancouver, BC",
      address: "2212 Clark Dr.",
      city: "Vancouver",
      province: "BC",
      postal: "V5N 3G8",
      phone: "236-427-0975",
      website: "/pages/vancouver",
      calendly: "https://calendly.com/vintageironcyclesvancouver/30min",
      lat: 49.264950,
      lng: -123.077095,
      timezone: "America/Vancouver",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_03_kelowna",
      name: "Kelowna, BC",
      address: "134-1735 Dolphin Ave",
      city: "Kelowna",
      province: "BC",
      postal: "V1Y 8A6",
      phone: "250-717-0522",
      website: "/pages/kelowna",
      calendly: "https://calendly.com/vicokanagan/appointment",
      lat: 49.878681,
      lng: -119.459707,
      timezone: "America/Vancouver",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "9:30 AM - 5:00 PM",
        "3": "9:30 AM - 5:00 PM",
        "4": "9:30 AM - 5:00 PM",
        "5": "9:30 AM - 5:00 PM",
        "6": "9:30 AM - 4:00 PM"
      }
    },
    {
      id: "loc_04_edmonton",
      name: "Edmonton, AB",
      address: "Unit 116, 2301 Premier Way",
      city: "Sherwood Park",
      province: "AB",
      postal: "T8H 2K8",
      phone: "780-400-3474",
      website: "/pages/edmonton",
      lat: 53.567708,
      lng: -113.317550,
      timezone: "America/Edmonton",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "11:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_05_reddeer",
      name: "Red Deer, AB",
      address: "7121E Gaetz Ave",
      city: "Red Deer",
      province: "AB",
      postal: "T4N 4E4",
      phone: "403-986-8500",
      website: "/pages/red-deer",
      lat: 52.298345,
      lng: -113.813805,
      timezone: "America/Edmonton",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "9:00 AM - 5:00 PM",
        "3": "9:00 AM - 5:00 PM",
        "4": "9:00 AM - 5:00 PM",
        "5": "9:00 AM - 5:00 PM",
        "6": "9:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_06_calgary",
      name: "Calgary, AB",
      address: "4209 – 6th Street SE",
      city: "Calgary",
      province: "AB",
      postal: "T2G 4E7",
      phone: "403-966-5262",
      website: "/pages/calgary",
      lat: 51.016889,
      lng: -114.049185,
      timezone: "America/Edmonton",
      schedule: {
        "0": "11:00 AM - 4:00 PM",
        "1": "9:00 AM - 6:00 PM",
        "2": "9:00 AM - 6:00 PM",
        "3": "9:00 AM - 6:00 PM",
        "4": "9:00 AM - 6:00 PM",
        "5": "9:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_07_medicinehat",
      name: "Medicine Hat, AB",
      address: "40 Strachan Ct SE Unit 1",
      city: "Medicine Hat",
      province: "AB",
      postal: "T1B 4R7",
      phone: "403-528-1070",
      website: "/pages/medicine-hat",
      lat: 49.999494,
      lng: -110.651058,
      timezone: "America/Edmonton",
      schedule: {
        "0": "Closed",
        "1": "10:00 AM - 6:00 PM",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_08_saskatoon",
      name: "Saskatoon, SK",
      address: "122 20th St W.",
      city: "Saskatoon",
      province: "SK",
      postal: "S7M 0W6",
      phone: "306-280-4853",
      website: "/pages/saskatoon",
      lat: 52.126431,
      lng: -106.671350,
      timezone: "America/Regina",
      schedule: {
        "0": "Closed",
        "1": "9:30 AM - 5:30 PM",
        "2": "9:30 AM - 5:30 PM",
        "3": "9:30 AM - 5:30 PM",
        "4": "9:30 AM - 5:30 PM",
        "5": "9:30 AM - 5:30 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_18_winnipeg",
      name: "Winnipeg, MB",
      address: "106 King Edward Street",
      city: "Winnipeg",
      province: "MB",
      postal: "R3H 0N8",
      phone: "204-227-2598",
      website: "/pages/winnipeg",
      lat: 49.921867,
      lng: -97.210403,
      timezone: "America/Winnipeg",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_09_hamiltonancaster",
      name: "Hamilton/Ancaster, ON",
      address: "1367 Osprey Dr #7",
      city: "Ancaster",
      province: "ON",
      postal: "L9G 4V5",
      phone: "289-443-1635",
      website: "/pages/hamiltonac",
      lat: 43.190465,
      lng: -80.026842,
      timezone: "America/Toronto",
      schedule: {
        "0": "11:00 AM - 4:00 PM",
        "1": "10:00 AM - 6:00 PM",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_11_kitchener",
      name: "Kitchener, ON",
      address: "935 Frederick Street #9",
      city: "Kitchener",
      province: "ON",
      postal: "N2B 2B9",
      phone: "519-744-1133",
      website: "/pages/kitchener-electronic-bike-store",
      lat: 43.465927,
      lng: -80.456566,
      timezone: "America/Toronto",
      schedule: {
        "0": "11:00 AM - 4:00 PM",
        "1": "10:00 AM - 6:00 PM",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_12_london",
      name: "London, ON",
      address: "207 Exeter Road - Unit C",
      city: "London",
      province: "ON",
      postal: "N6L 1A4",
      phone: "519-207-0879",
      website: "/pages/london-electric-bike-store",
      lat: 42.921689,
      lng: -81.260743,
      timezone: "America/Toronto",
      schedule: {
        "0": "Closed",
        "1": "10:00 AM - 6:00 PM",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "9:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_13_newmarket",
      name: "Newmarket, ON",
      address: "17480 Yonge Street",
      city: "Newmarket",
      province: "ON",
      postal: "L3Y 8A8",
      phone: "647-874-1429",
      website: "/pages/newmarket",
      lat: 44.053948,
      lng: -79.481286,
      timezone: "America/Toronto",
      schedule: {
        "0": "10:00 AM - 5:00 PM",
        "1": "10:00 AM - 6:00 PM",
        "2": "10:00 AM - 6:00 PM",
        "3": "10:00 AM - 6:00 PM",
        "4": "10:00 AM - 6:00 PM",
        "5": "10:00 AM - 6:00 PM",
        "6": "9:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_15_charlottetown",
      name: "Charlottetown, PEI",
      address: "306 University Avenue",
      city: "Charlottetown",
      province: "PE",
      postal: "C1A 4M4",
      phone: "902-569-2895",
      website: "/pages/charlottetown",
      lat: 46.241530,
      lng: -63.131900,
      timezone: "America/Halifax",
      schedule: {
        "0": "Closed",
        "1": "10:00 AM - 5:00 PM",
        "2": "10:00 AM - 5:00 PM",
        "3": "10:00 AM - 5:00 PM",
        "4": "10:00 AM - 5:00 PM",
        "5": "10:00 AM - 5:00 PM",
        "6": "9:00 AM - 4:00 PM"
      }
    },
    {
      id: "loc_16_halifax",
      name: "Halifax/Dartmouth, NS",
      address: "26 Bancroft Drive",
      city: "Dartmouth",
      province: "NS",
      postal: "B3B 1G3",
      phone: "902-407-8688",
      website: "/pages/darmouth-halifax",
      lat: 44.697956,
      lng: -63.605177,
      timezone: "America/Halifax",
      schedule: {
        "0": "Closed",
        "1": "10:00 AM - 5:00 PM",
        "2": "10:00 AM - 5:00 PM",
        "3": "10:00 AM - 5:00 PM",
        "4": "10:00 AM - 5:00 PM",
        "5": "10:00 AM - 5:00 PM",
        "6": "10:00 AM - 5:00 PM"
      }
    },
    {
      id: "loc_17_stjohns",
      name: "St. John's, NL",
      address: "60 O'Leary Avenue",
      city: "St. John's",
      province: "NL",
      postal: "A1B 2C7",
      phone: "709-747-2633",
      website: "/pages/st-johns",
      lat: 47.559938,
      lng: -52.763392,
      timezone: "America/St_Johns",
      schedule: {
        "0": "Closed",
        "1": "Closed",
        "2": "10:00 AM - 5:00 PM",
        "3": "10:00 AM - 5:00 PM",
        "4": "10:00 AM - 5:00 PM",
        "5": "10:00 AM - 5:00 PM",
        "6": "9:00 AM - 3:00 PM"
      }
    }
  ];

  let VIC_STORES = [];

  function parseStoreData() {
    const scriptEl = document.getElementById("vicStoreData");
    let customStores = [];
    if (scriptEl) {
      try {
        const parsed = JSON.parse(scriptEl.textContent);
        if (Array.isArray(parsed)) {
          customStores = parsed.filter(store => store && store.id && store.id.trim() !== "" && store.name && store.name.trim() !== "");
        }
      } catch (e) {
        console.warn("Failed to parse store data from theme blocks:", e);
      }
    }

    // Start with a clean copy of the default 17 stores
    const merged = DEFAULT_STORES.map(s => {
      const copy = Object.assign({}, s);
      if (s.schedule) {
        copy.schedule = Object.assign({}, s.schedule);
      }
      return copy;
    });

    // Merge custom stores from blocks
    customStores.forEach(custom => {
      const idx = merged.findIndex(s => s.id === custom.id);
      if (idx !== -1) {
        // Update existing store details (only override non-blank settings)
        const existing = merged[idx];
        Object.keys(custom).forEach(key => {
          if (custom[key] !== null && custom[key] !== undefined && custom[key] !== "") {
            if (key === "lat" || key === "lng") {
              if (custom[key] !== 0) {
                existing[key] = custom[key];
              }
            } else if (key === "schedule") {
              // Merge schedule days
              Object.keys(custom.schedule).forEach(day => {
                if (custom.schedule[day] !== null && custom.schedule[day] !== undefined && custom.schedule[day] !== "") {
                  existing.schedule[day] = custom.schedule[day];
                }
              });
            } else {
              existing[key] = custom[key];
            }
          }
        });
      } else {
        // If it's a completely new store, append it!
        merged.push(custom);
      }
    });

    VIC_STORES = merged;
  }

  const STORAGE_KEY = "vic_nearest_store_override";

  function haversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function findClosestStore(lat, lng) {
    let closestStore = null;
    let minDistance = Infinity;

    VIC_STORES.forEach(function (store) {
      const dist = haversineDistance(lat, lng, store.lat, store.lng);
      if (dist < minDistance) {
        minDistance = dist;
        closestStore = Object.assign({}, store, { distance: dist });
      }
    });

    return closestStore;
  }

  function parseTime(timeStr) {
    if (!timeStr) return null;
    const match = timeStr.trim().match(/^(\d+):(\d+)\s*(AM|PM)$/i);
    if (!match) return null;
    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const ampm = match[3].toUpperCase();
    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;
    return hours + minutes / 60;
  }

  function isStoreOpen(store) {
    if (!store.schedule || !store.timezone) return true;
    try {
      const storeLocalString = new Date().toLocaleString("en-US", { timeZone: store.timezone });
      const storeLocalDate = new Date(storeLocalString);
      const day = storeLocalDate.getDay(); // 0 = Sun, 1 = Mon, etc.
      
      const hoursSetting = store.schedule[day];
      if (!hoursSetting || hoursSetting.toLowerCase().includes("closed")) {
        return false;
      }
      
      const parts = hoursSetting.split("-");
      if (parts.length !== 2) return true;
      
      const openTime = parseTime(parts[0]);
      const closeTime = parseTime(parts[1]);
      if (openTime === null || closeTime === null) return true;
      
      const currentHours = storeLocalDate.getHours() + storeLocalDate.getMinutes() / 60;
      return currentHours >= openTime && currentHours < closeTime;
    } catch (e) {
      return true;
    }
  }

  function getStoreStatusText(store) {
    if (!store.schedule || !store.timezone) {
      return { isOpen: true, text: " Open Now" };
    }
    try {
      const storeLocalString = new Date().toLocaleString("en-US", { timeZone: store.timezone });
      const storeLocalDate = new Date(storeLocalString);
      const day = storeLocalDate.getDay(); // 0 = Sun, 1 = Mon, etc.
      const currentHours = storeLocalDate.getHours() + storeLocalDate.getMinutes() / 60;
      
      const hoursSetting = store.schedule[day];
      const isClosedToday = !hoursSetting || hoursSetting.toLowerCase().includes("closed");
      
      let todayOpenTime = null;
      let todayCloseTime = null;
      let todayOpenStr = "";
      let todayCloseStr = "";
      
      if (!isClosedToday) {
        const parts = hoursSetting.split("-");
        if (parts.length === 2) {
          todayOpenStr = parts[0].trim();
          todayCloseStr = parts[1].trim();
          todayOpenTime = parseTime(todayOpenStr);
          todayCloseTime = parseTime(todayCloseStr);
        }
      }
      
      // Case 1: Open right now
      if (!isClosedToday && todayOpenTime !== null && todayCloseTime !== null && currentHours >= todayOpenTime && currentHours < todayCloseTime) {
        return {
          isOpen: true,
          text: ` Open Now (Closes: ${todayCloseStr})`
        };
      }
      
      // Case 2: Closed today, but opens later today
      if (!isClosedToday && todayOpenTime !== null && currentHours < todayOpenTime) {
        return {
          isOpen: false,
          text: ` Closed (Opens today: ${todayOpenStr})`
        };
      }
      
      // Case 3: Closed today (after closing or all day), look for next opening day
      const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      for (let i = 1; i <= 7; i++) {
        const nextDay = (day + i) % 7;
        const nextDaySetting = store.schedule[nextDay];
        if (nextDaySetting && !nextDaySetting.toLowerCase().includes("closed")) {
          const parts = nextDaySetting.split("-");
          if (parts.length === 2) {
            const nextOpenStr = parts[0].trim();
            const dayLabel = i === 1 ? "tomorrow" : dayNames[nextDay];
            return {
              isOpen: false,
              text: ` Closed (Opens ${dayLabel}: ${nextOpenStr})`
            };
          }
        }
      }
      
      // Fallback
      return {
        isOpen: false,
        text: " Closed"
      };
    } catch (e) {
      return { isOpen: true, text: " Open Now" };
    }
  }

  class VICNearestStoreWidget {
    constructor() {
      this.widget = document.getElementById("vicNearestStoreWidget");
      this.pdpCard = document.getElementById("vicProductStoreCard");
      
      // If neither is present, return early
      if (!this.widget && !this.pdpCard) return;

      this.trigger = this.widget ? this.widget.querySelector(".vic-nearest-store-trigger") : null;
      this.triggerText = this.widget ? this.widget.querySelector(".vic-nearest-store-text") : null;
      this.dropdown = this.widget ? this.widget.querySelector(".vic-nearest-store-dropdown") : null;
      this.storeSelect = document.getElementById("vicStoreSelect");
      this.pdpStoreSelect = document.getElementById("vicPdpStoreSelect");

      this.closestStore = null;
      this.init();
    }

    init() {
      this.populateDropdownOptions();
      this.bindEvents();
      this.resolveLocation();
    }

    populateDropdownOptions() {
      // Header dropdown select
      if (this.storeSelect) {
        while (this.storeSelect.options.length > 1) {
          this.storeSelect.remove(1);
        }
        VIC_STORES.forEach(store => {
          const opt = document.createElement("option");
          opt.value = store.id;
          opt.textContent = `${store.city}, ${store.province}`;
          this.storeSelect.appendChild(opt);
        });
      }

      // PDP card dropdown select
      if (this.pdpStoreSelect) {
        while (this.pdpStoreSelect.options.length > 1) {
          this.pdpStoreSelect.remove(1);
        }
        VIC_STORES.forEach(store => {
          const opt = document.createElement("option");
          opt.value = store.id;
          opt.textContent = `${store.city}, ${store.province}`;
          this.pdpStoreSelect.appendChild(opt);
        });
      }
    }

    bindEvents() {
      // Toggle dropdown open/closed
      if (this.trigger) {
        this.trigger.addEventListener("click", e => {
          e.stopPropagation();
          const isOpen = this.widget.classList.contains("vic-open");
          if (isOpen) {
            this.closeDropdown();
          } else {
            this.openDropdown();
          }
        });
      }

      // Close dropdown when clicking outside
      document.addEventListener("click", e => {
        if (this.widget && !this.widget.contains(e.target)) {
          this.closeDropdown();
        }
      });

      // Keyboard Esc key to close dropdown
      document.addEventListener("keydown", e => {
        if (e.key === "Escape") {
          this.closeDropdown();
        }
      });

      // Prevent closing when clicking inside the dropdown
      if (this.dropdown) {
        this.dropdown.addEventListener("click", e => {
          e.stopPropagation();
        });
      }

      // Manual select override for header selector
      if (this.storeSelect) {
        this.storeSelect.addEventListener("change", e => {
          const selectedId = e.target.value;
          if (selectedId) {
            const matchedStore = VIC_STORES.find(s => s.id === selectedId);
            if (matchedStore) {
              this.saveAndApplyOverride(matchedStore);
            }
          }
        });
      }

      // Manual select override for PDP card selector
      if (this.pdpStoreSelect) {
        this.pdpStoreSelect.addEventListener("change", e => {
          const selectedId = e.target.value;
          if (selectedId) {
            const matchedStore = VIC_STORES.find(s => s.id === selectedId);
            if (matchedStore) {
              this.saveAndApplyOverride(matchedStore);
            }
          }
        });
      }

      // "Use my location" button
      const detectBtn = document.getElementById("vicDetectLocationBtn");
      if (detectBtn) {
        detectBtn.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          localStorage.removeItem(STORAGE_KEY);
          localStorage.removeItem('vic_user_coords');
          if (this.triggerText) {
            this.triggerText.innerHTML = '<span class="vic-store-prefix">Detecting Store...</span>';
          }
          const pdpCityEl = document.querySelector(".vic-pdp-store-city");
          if (pdpCityEl) {
            pdpCityEl.textContent = "Detecting showroom...";
          }
          const pdpStatusEl = document.querySelector(".vic-pdp-store-status");
          if (pdpStatusEl) {
            pdpStatusEl.textContent = "Detecting hours...";
          }
          this.resolveLocation();
        });
      }
    }

    openDropdown() {
      if (!this.widget) return;
      this.widget.classList.add("vic-open");
      this.trigger.setAttribute("aria-expanded", "true");
      this.dropdown.setAttribute("aria-hidden", "false");
    }

    closeDropdown() {
      if (!this.widget) return;
      this.widget.classList.remove("vic-open");
      this.trigger.setAttribute("aria-expanded", "false");
      this.dropdown.setAttribute("aria-hidden", "true");
    }

    saveAndApplyOverride(store) {
      const cachedCoordsStr = localStorage.getItem('vic_user_coords');
      if (cachedCoordsStr) {
        try {
          const coords = JSON.parse(cachedCoordsStr);
          if (coords && coords.lat && coords.lng) {
            store.distance = haversineDistance(coords.lat, coords.lng, store.lat, store.lng);
          }
        } catch (e) {}
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      this.closestStore = store;
      this.updateUI(store, true);
    }

    resolveLocation() {
      const savedOverride = localStorage.getItem(STORAGE_KEY);
      if (savedOverride) {
        try {
          const store = JSON.parse(savedOverride);
          if (store && store.id) {
            this.closestStore = store;
            // Check if we have cached coords to calculate distance
            const cachedCoordsStr = localStorage.getItem('vic_user_coords');
            if (cachedCoordsStr) {
              try {
                const coords = JSON.parse(cachedCoordsStr);
                if (coords && coords.lat && coords.lng) {
                  store.distance = haversineDistance(coords.lat, coords.lng, store.lat, store.lng);
                }
              } catch (e) {}
              this.updateUI(store, true);
            } else {
              // No cached coords, do a background silent IP lookup to get approximate distance
              this.bgIPLookup(store);
            }
            return;
          }
        } catch (e) {
          localStorage.removeItem(STORAGE_KEY);
        }
      }

      // Check if we have cached user coords
      const cachedCoordsStr = localStorage.getItem('vic_user_coords');
      if (cachedCoordsStr) {
        try {
          const coords = JSON.parse(cachedCoordsStr);
          if (coords && coords.lat && coords.lng) {
            const store = findClosestStore(coords.lat, coords.lng);
            if (store) {
              this.closestStore = store;
              this.updateUI(store, false);
              return;
            }
          }
        } catch (e) {}
      }

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          pos => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;
            localStorage.setItem('vic_user_coords', JSON.stringify({ lat, lng }));
            const store = findClosestStore(lat, lng);
            if (store) {
              this.closestStore = store;
              this.updateUI(store, false);
            } else {
              this.fallbackIP();
            }
          },
          () => {
            this.fallbackIP();
          },
          { timeout: 4000, maximumAge: 300000 }
        );
      } else {
        this.fallbackIP();
      }
    }

    bgIPLookup(store) {
      fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
          if (data.latitude && data.longitude) {
            localStorage.setItem('vic_user_coords', JSON.stringify({ lat: data.latitude, lng: data.longitude }));
            store.distance = haversineDistance(data.latitude, data.longitude, store.lat, store.lng);
            this.updateUI(store, true);
          } else {
            this.updateUI(store, true);
          }
        })
        .catch(() => {
          this.updateUI(store, true);
        });
    }

    fallbackIP() {
      fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
          if (data.latitude && data.longitude) {
            const lat = data.latitude;
            const lng = data.longitude;
            localStorage.setItem('vic_user_coords', JSON.stringify({ lat, lng }));
            const store = findClosestStore(lat, lng);
            if (store) {
              this.closestStore = store;
              this.updateUI(store, false);
            } else {
              this.loadDefaultStore();
            }
          } else {
            this.loadDefaultStore();
          }
        })
        .catch(() => {
          this.loadDefaultStore();
        });
    }

    loadDefaultStore() {
      const defaultStore = VIC_STORES.find(s => s.id === "loc_06_calgary");
      this.closestStore = defaultStore;
      this.updateUI(defaultStore, false);
    }

    updateUI(store, isOverride) {
      if (!store) return;

      const storeCalendly = store.calendly || "";

      // 1. UPDATE HEADER WIDGET (if present)
      if (this.widget && this.triggerText) {
        // Update Header trigger text (NO EMOJI!)
        let triggerLabel = `<span class="vic-store-prefix">Nearest Store: </span><span class="vic-store-location">${store.city}</span>`;
        if (isOverride) {
          triggerLabel = `<span class="vic-store-prefix">Your Store: </span><span class="vic-store-location">${store.city}</span>`;
        } else if (store.distance && !isOverride) {
          triggerLabel = `<span class="vic-store-prefix">Nearest Store: </span><span class="vic-store-location">${store.city} <span class="vic-store-distance-badge">(${Math.round(store.distance)} km)</span></span>`;
        }
        this.triggerText.innerHTML = triggerLabel;

        // Update Dropdown header title
        const dropdownHeaderTitle = this.widget.querySelector(".vic-nearest-store-header h4");
        if (dropdownHeaderTitle) {
          const defaultHeading = dropdownHeaderTitle.getAttribute("data-default-heading") || "Nearest Showroom";
          dropdownHeaderTitle.textContent = isOverride ? defaultHeading.replace(/Nearest/i, "Your") : defaultHeading;
        }

        // Update dropdown details
        const detailContainer = this.widget.querySelector(".vic-nearest-store-details");
        if (detailContainer) {
          detailContainer.querySelector(".vic-store-name").textContent = store.name;
          detailContainer.querySelector(".vic-store-address").textContent = store.address;

          const distanceEl = detailContainer.querySelector(".vic-store-distance");
          if (store.distance && !isOverride) {
            distanceEl.textContent = `Distance: ~${Math.round(store.distance)} km away`;
            distanceEl.style.display = "block";
          } else {
            distanceEl.style.display = "none";
          }

          const phoneEl = detailContainer.querySelector(".vic-store-phone");
          if (store.phone) {
            phoneEl.innerHTML = `Phone: <a href="tel:${store.phone.replace(/[^0-9]/g, "")}">${store.phone}</a>`;
            phoneEl.style.display = "block";
          } else {
            phoneEl.style.display = "none";
          }
        }

        // Update Live Indicator status (Open Now / Closed) based on timezone operating hours
        const indicatorEl = this.widget.querySelector(".vic-live-indicator");
        if (indicatorEl) {
          const status = getStoreStatusText(store);
          const dot = indicatorEl.querySelector(".vic-live-dot");
          indicatorEl.innerHTML = "";
          indicatorEl.appendChild(dot);
          if (status.isOpen) {
            indicatorEl.classList.remove("vic-closed");
          } else {
            indicatorEl.classList.add("vic-closed");
          }
          indicatorEl.appendChild(document.createTextNode(status.text));
        }

        // Update Action Links
        const directionsBtn = this.widget.querySelector(".vic-btn-directions");
        if (directionsBtn) {
          const destination = encodeURIComponent(`${store.address}, ${store.city}, ${store.province}, Canada`);
          directionsBtn.href = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
        }

        const pageBtn = this.widget.querySelector(".vic-btn-page");
        if (pageBtn) {
          pageBtn.href = store.website;
        }

        // Set manual dropdown selector value to match
        if (this.storeSelect) {
          this.storeSelect.value = store.id;
        }

        // Check if distance is < 25km and style as highlighted (dark background / white text)
        this.widget.classList.remove("vic-pulse-attention");
        if (store.distance && store.distance < 25 && !isOverride) {
          this.widget.classList.add("vic-pulse-attention");
        }

        // Make widget visible
        this.widget.style.display = "inline-block";
      }

      // 2. UPDATE PRODUCT PAGE STORE CARD (if present)
      if (this.pdpCard) {
        const showPhone = this.pdpCard.getAttribute("data-show-phone") !== "false";
        const showDirections = this.pdpCard.getAttribute("data-show-directions") !== "false";
        const showWebsite = this.pdpCard.getAttribute("data-show-website") !== "false";
        const showTestRide = this.pdpCard.getAttribute("data-show-test-ride") !== "false";
        const showSelector = this.pdpCard.getAttribute("data-show-selector") !== "false";

        // Update store city
        const pdpCityEl = this.pdpCard.querySelector(".vic-pdp-store-city");
        if (pdpCityEl) {
          pdpCityEl.textContent = store.name;
        }

        // Update address & phone
        const pdpAddressEl = this.pdpCard.querySelector(".vic-pdp-store-address");
        if (pdpAddressEl) {
          pdpAddressEl.textContent = store.address;
        }

        const pdpPhoneEl = this.pdpCard.querySelector(".vic-pdp-store-phone");
        if (pdpPhoneEl) {
          if (store.phone && showPhone) {
            pdpPhoneEl.innerHTML = `Phone: <a href="tel:${store.phone.replace(/[^0-9]/g, "")}">${store.phone}</a>`;
            pdpPhoneEl.style.display = "block";
          } else {
            pdpPhoneEl.style.display = "none";
          }
        }

        // Update distance badge/text
        const pdpDistanceEl = this.pdpCard.querySelector(".vic-pdp-store-distance");
        if (pdpDistanceEl) {
          if (store.distance && !isOverride) {
            pdpDistanceEl.textContent = `(${Math.round(store.distance)} km away)`;
            pdpDistanceEl.style.display = "inline";
          } else {
            pdpDistanceEl.style.display = "none";
          }
        }

        // Update Live Status indicator
        const pdpIndicatorEl = this.pdpCard.querySelector("#vicPdpLiveIndicator");
        if (pdpIndicatorEl) {
          const status = getStoreStatusText(store);
          const statusTextEl = pdpIndicatorEl.querySelector(".vic-pdp-store-status");
          if (statusTextEl) {
            statusTextEl.textContent = status.text.trim();
          }
          if (status.isOpen) {
            pdpIndicatorEl.classList.remove("vic-closed");
          } else {
            pdpIndicatorEl.classList.add("vic-closed");
          }
        }

        // Update dynamic CTA buttons
        const pdpBookingBtn = this.pdpCard.querySelector(".vic-pdp-btn-booking");
        if (pdpBookingBtn) {
          if (storeCalendly && showTestRide) {
            pdpBookingBtn.href = storeCalendly;
            pdpBookingBtn.style.display = "block";
          } else {
            pdpBookingBtn.style.display = "none";
          }
        }

        const pdpDirectionsBtn = this.pdpCard.querySelector(".vic-pdp-btn-directions");
        if (pdpDirectionsBtn) {
          if (showDirections) {
            const destination = encodeURIComponent(`${store.address}, ${store.city}, ${store.province}, Canada`);
            pdpDirectionsBtn.href = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
            pdpDirectionsBtn.style.display = "inline-flex";
          } else {
            pdpDirectionsBtn.style.display = "none";
          }
        }

        const pdpPageBtn = this.pdpCard.querySelector(".vic-pdp-btn-page");
        if (pdpPageBtn) {
          if (showWebsite) {
            pdpPageBtn.href = store.website;
            pdpPageBtn.style.display = "inline-flex";
          } else {
            pdpPageBtn.style.display = "none";
          }
        }

        // Sync dropdown selector on product page card
        if (this.pdpStoreSelect) {
          this.pdpStoreSelect.value = store.id;
        }

        // Show/hide selectors override container
        const pdpOverrideSec = this.pdpCard.querySelector(".vic-pdp-override-section");
        if (pdpOverrideSec) {
          pdpOverrideSec.style.display = showSelector ? "block" : "none";
        }

        // Display the card
        this.pdpCard.style.display = "block";
      }
    }
  }

  function initNearestStoreWidget() {
    parseStoreData();
    new VICNearestStoreWidget();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNearestStoreWidget);
  } else {
    initNearestStoreWidget();
  }

  // Support Shopify Theme Editor dynamic section reloads
  document.addEventListener("shopify:section:load", function (evt) {
    if (evt.target.querySelector("#vicNearestStoreWidget") || evt.target.querySelector("#vicProductStoreCard")) {
      initNearestStoreWidget();
    }
  });
})();

